import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { NgcCookieConsentService } from 'ngx-cookieconsent';


@Injectable()
export class CookieService {

    constructor(private ccService: NgcCookieConsentService,
        private translate: TranslateService) { }

    updateCookiesLang() {
        // const browserLang = this.translate.getBrowserLang();
        // this.translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
        this.translate//
            .get(['cookie.header', 'cookie.message', 'cookie.dismiss', 'cookie.allow', 'cookie.deny', 'cookie.link'])
            .subscribe(data => {
                this.ccService.getConfig().content = this.ccService.getConfig().content || {};
                // Override default messages with the translated ones
                this.ccService.getConfig().content.header = data['cookie.header'];
                this.ccService.getConfig().content.message = data['cookie.message'];
                this.ccService.getConfig().content.dismiss = data['cookie.dismiss'];
                this.ccService.getConfig().content.allow = data['cookie.allow'];
                this.ccService.getConfig().content.deny = data['cookie.deny'];
                this.ccService.getConfig().content.link = data['cookie.link'];

                this.ccService.destroy();//remove previous cookie bar (with default messages)
                this.ccService.init(this.ccService.getConfig()); // update config with translated messages
            });
    }

}






// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/shared/cookie.service.ts